export const members = [
    {
        title: 'Postdoctoral Fellow',
        name: 'Tiantian Zhang',
        avatar: 'tiantian.png',
    },
    {
        title: 'Postdoctoral Fellow',
        name: 'Xiang Chen',
        avatar: 'xiang.png',
    },
    {
        title: 'Research Technician',
        name: 'Michelle Chen',
        avatar: 'michelle.png',
    },
    {
        title: 'Research Assistant',
        name: 'Sathirtha Mondal',
        avatar: 'sathirtha.png',
    },
    {
        title: 'Research Assistant',
        name: 'Marjona Mirzaeva',
        avatar: 'marjona.png',
    },
    {
        title: 'Research Assistant',
        name: 'David Siniscalco',
        avatar: 'david.png',
    },
    {
        title: 'Research Assistant',
        name: 'Michael Boyuan Li',
        avatar: 'michael.png',
    },
]